import intl from 'react-intl-universal';
import moment from 'moment';

export function formatDateTime(ts) {
  const d = new Date(ts);
  const noon = 12;
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const date = `${d.getDate()}`.padStart(2, '0');
  const minutes = `${d.getUTCMinutes()}`.padStart(2, '0');
  let hours = d.getUTCHours();
  let meridiem = 'am';

  const dayLimit = new Date().getTime() - 1 * 24 * 60 * 60 * 1000;
  const twoDayLimit = new Date().getTime() - 2 * 24 * 60 * 60 * 1000;
  const weekLimit = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
  const yearLimit = new Date().getTime() - 365 * 24 * 60 * 60 * 1000;

  if (hours > noon) {
    hours = `${hours - noon}`.padStart(2, '0');
    meridiem = 'pm';
  } else if (!hours) {
    hours = noon;
  }

  if (d > dayLimit) {
    return `${hours}:${minutes}${meridiem}`;
  }

  if (d > twoDayLimit && d < dayLimit) {
    return `Yesterday, ${hours}:${minutes}${meridiem}`;
  }

  if (d > weekLimit && d < twoDayLimit) {
    const { currentLocale, locales } = intl.options;
    const days = locales[currentLocale].date.daysOfWeek;
    return `${days[d.getDay()]} ${hours}:${minutes}${meridiem}`;
  }

  if (d > weekLimit) {
    return `${month}/${date}, ${hours}:${minutes}${meridiem}`;
  }

  if (d > yearLimit) {
    return `${month}/${date}, ${hours}:${minutes}${meridiem}`;
  }

  return `${month}/${date}/${d.getFullYear()}, ${hours}:${minutes}${meridiem}`;
}

export function formatReplyDate(ts) {
  const d = new Date(ts);

  const date = `${d.getDate()}`.padStart(2, '0');
  const minutes = `${d.getMinutes()}`.padStart(2, '0');
  const noon = 12;

  let hours = d.getUTCHours();
  let meridiem = 'am';

  if (hours > noon) {
    hours = `${hours - noon}`.padStart(2, '0');
    meridiem = 'pm';
  } else if (!hours) {
    hours = noon;
  }

  const { currentLocale, locales } = intl.options;
  const months = locales[currentLocale].date.monthsOfYear;

  return `${date} ${months[d.getMonth()]} ${d.getFullYear()} at ${hours}:${minutes}${meridiem}`;
}

export function formatDDMMYY(ts) {
  // 12-Sep-2019
  if (ts) {
    const d = new Date(ts);
    const date = `${d.getDate()}`.padStart(2, '0');
    const { currentLocale, locales } = intl.options;
    const months = locales[currentLocale].date.monthsOfShort;

    return `${date}-${months[d.getMonth()]}-${d.getFullYear()}`;
  }
}

export function formatDDMMMMYY(ts) {
  // 12-September-2019
  const d = new Date(ts);
  const date = `${d.getDate()}`.padStart(2, '0');
  const { currentLocale, locales } = intl.options;
  const months = locales[currentLocale].date.monthsOfYear;

  return `${date}-${months[d.getMonth()]}-${d.getFullYear()}`;
}

export function getTodaysDate(format) {
  const d = new Date();
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const date = `${d.getDate()}`.padStart(2, '0');

  if (format === 'utc') {
    return `${d.getFullYear()}-${month}-${date}`;
  }

  return `${month}/${date}/${d.getFullYear()}`;
}

export const momentoFormatWrapper = dateString => {
  let parsedDateString;
  if (dateString.indexOf('-') !== -1) {
    // Fix for IE and EDGE as IE dont support other format then iso and rfc
    // also it solve firfox -- issue of format ex 23-jan--2019
    parsedDateString = moment(
      moment(dateString, 'DD-MMM-YYYY')
        .toDate()
        .toISOString(),
    ).format('DD-MMM-YYYY');
  } else if (dateString.indexOf('/') !== -1) {
    // Server sends in format which is valid for ie standard format ex 1/9/2018 12:00:00 AM
    parsedDateString = moment(dateString).format('DD-MMM-YYYY');
  }
  return parsedDateString;
};

// export function getTodaysDate(format) {
//   const d = new Date();
//   const month = `${d.getMonth() + 1}`.padStart(2, '0');
//   const date = `${d.getDate()}`.padStart(2, '0');

//   if (format === 'utc') {
//     return `${d.getFullYear()}-${month}-${date}`;
//   }

//   return `${month}/${date}/${d.getFullYear()}`;
// }

export function formatCasePhaseDate(ts) {
  const d = new Date(`${ts}Z`);
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const date = `${d.getDate()}`.padStart(2, '0');

  return `${month}/${date}/${d
    .getFullYear()
    .toString()
    .substr(-2)}`;
}



// WEBPACK FOOTER //
// ./src/helpers/date.js